interface TextInputViewProps {
  id?: string;
  name?: string;
  type?: string;
  value: string;
  placeholder?: string;
  label?: string;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  autoComplete?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  className?: string;
}

export const TextInputView = ({
  id,
  name,
  type = "text",
  value,
  placeholder,
  label,
  error,
  disabled = false,
  required = false,
  autoComplete,
  onChange,
  onBlur,
  className = "",
}: TextInputViewProps) => {
  const inputClasses = `block w-full px-4 py-3 text-foreground border rounded-lg bg-surface-subtle focus-visible:shadow-focus transition-all duration-200 outline-none ${
    error ? "border-destructive" : "border-input"
  } ${disabled ? "bg-surface-sunken cursor-not-allowed opacity-60" : ""} ${className}`;

  return (
    <div className="mb-5">
      {label && (
        <label
          htmlFor={id || name}
          className="mb-2 block text-sm font-semibold text-muted-foreground"
        >
          {label}
          {required && <span className="ml-1 text-destructive">*</span>}
        </label>
      )}
      <input
        id={id || name}
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        required={required}
        autoComplete={autoComplete}
        className={inputClasses}
      />
      {error && <p className="mt-1.5 text-xs font-medium text-destructive-text">{error}</p>}
    </div>
  );
};
